import Entity from './entity'
export default class Gasthreshold extends Entity<number>{
    tName:string;
}